module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/ygabn-logo.1b78b.png";